"use client";

import { Separator } from "@base-ui/react";
import { useState } from "react";
import ArrowIcon from "@/components/icons/arrow";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// todo: change div background to Image | performance
const carouselItems = [
  {
    description:
      "Hamilelikle başlayan dönem yeni sorumlulukları da beraberinde getirir. Eve yeni gelecek olan bebeğinizin bakımı, giyimi, beslenmesi, uyku zamanları derken yorucu günler için kendinizi hazırlamanız...",
    id: 1,
    image:
      "https://ebebek-cms-assets.s3.eu-north-1.amazonaws.com/client_tmp/momandbaby-7bd14c4d.webp",
    thumbnail:
      "https://ebebek-cms-assets.s3.eu-north-1.amazonaws.com/client_tmp/thumbs/t3-1cc960ea.webp",
    title: "Kış Aylarında Bebek Bakımı Nasıl Olmalıdır?",
  },
  {
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam laudantium natus, alias, voluptatem voluptatibus amet blanditiis quos at quisquam dolore corporis similique dicta veniam sunt dignissimos ad! Natus, voluptatum atque.",
    id: 2,
    image:
      "https://ebebek-cms-assets.s3.eu-north-1.amazonaws.com/client_tmp/c2-a2dc1580.webp",
    thumbnail:
      "https://ebebek-cms-assets.s3.eu-north-1.amazonaws.com/client_tmp/thumbs/t4-41ad1b36.webp",
    title: "Bebek Sağlığı",
  },
];

const MiniCarousel = () => {
  const [activeItem, setActiveItem] = useState(0);

  return (
    <div className="aspect-4/5 z-0 w-full relative">
      {carouselItems.map((item, index) => (
        <div
          className={`absolute inset-0 rounded-2xl flex flex-col justify-center px-4 transition-opacity duration-500 ease-in-out ${
            activeItem === index
              ? "opacity-100 z-10"
              : "opacity-0 z-0 pointer-events-none"
          }`}
          key={item.id}
          style={{
            backgroundImage: `radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%), url(${item.image})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
            width: "100%",
          }}
        >
          <div className="w-full shrink-0 flex flex-col justify-end gap-4">
            <h2 className={cn("text-[22px] leading-8 font-bold text-white")}>
              {item.title}
            </h2>
            <p className="text-sm leading-5 font-medium text-white line-clamp-2">
              {item.description}
            </p>
            <Button className="w-fit hover:bg-brand-blue-500">
              Devamı <ArrowIcon className="stroke-white" />
            </Button>
          </div>
        </div>
      ))}
      <div
        className="absolute bottom-0 p-4 pt-2 z-20 w-full"
        id="carousel-indicators"
      >
        <div className="w-full flex flex-row gap-2 border-t pt-3 border-neutral-200">
          {carouselItems.map((item, index) => (
            <div
              className={cn("size-14 bg-white rounded-lg cursor-pointer")}
              // biome-ignore lint/suspicious/noArrayIndexKey: its ok
              key={index}
              onClick={() => setActiveItem(index)}
              role="none"
            >
              <div
                className={`inset-0 rounded-lg ${
                  activeItem === index
                    ? "border-2 md:border-4 border-transparent"
                    : ""
                }`}
                style={{
                  backgroundClip: "padding-box, border-box",
                  backgroundImage:
                    activeItem === index
                      ? `url(${item.thumbnail}), conic-gradient(from 0deg, var(--brand-blue) 0deg 90deg, #FFFFFF 90deg 360deg)`
                      : `url(${item.thumbnail})`,
                  backgroundOrigin: "padding-box, border-box",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MiniCarousel;
